<template>
    <div class="sources">
        <h3 class="widget-title">
            Sources
        </h3>
        <data-loader :data="chartData">
            <DoughnutChart
                :data="chartData"
                label-key="source"
            />
        </data-loader>
    </div>
</template>

<script>

/**
 * External dependencies
 */
import { mapActions, mapState } from 'vuex';

/**
 * Internal dependencies
 */
import analyticsData from '@/mixins/analyticsData';
import DataLoader from '@/components/DataLoader';
import DoughnutChart from './Charts/DoughnutChart';

export default {
    components: {
        DataLoader,
        DoughnutChart,
    },

    mixins: [
        analyticsData,
    ],

    props: {
        from: {
            type: String,
            default: null,
        },
        showHash: {
            type: String,
            default: null,
        },
        to: {
            type: String,
            default: null,
        },
    },

    computed: {
        ...mapState({
            analyticsData: 'sources',
        }),
    },

    methods: {
        ...mapActions({
            loadData: 'loadSources',
        }),
    },
};
</script>
